(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage_product_tab"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dd-product-tabs')) {
  customElements.define('dd-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        event.preventDefault();
        this.selectTab(tab);
      }, options);
      this.addEventListener('keydown', event => {
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const index = tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.selectTab(tabs[next]);
        tabs[next].focus({ preventScroll: true });
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const panel = Array.from(this.querySelectorAll('[role="tabpanel"]')).find(item => item.dataset.blockId === event.detail?.blockId);
        if (panel) this.selectTab(this.querySelector(`[aria-controls="${panel.id}"]`));
      }, options);
      requestAnimationFrame(() => {
        if (this.isConnected) this.selectTab(this.querySelector('[role="tab"][aria-selected="true"]') || this.querySelector('[role="tab"]'));
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
    selectTab(selected) {
      if (!selected) return;
      const panelId = selected.getAttribute('aria-controls');
      this.querySelectorAll('[role="tab"]').forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('active', active);
      });
      this.querySelectorAll('[role="tabpanel"]').forEach(panel => { panel.hidden = panel.id !== panelId; });
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const panel = this.querySelector('[role="tabpanel"]:not([hidden])');
        panel?.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
        const list = selected.closest('[role="tablist"]');
        if (!list) return;
        const itemRect = selected.getBoundingClientRect();
        const listRect = list.getBoundingClientRect();
        if (itemRect.left < listRect.left) list.scrollLeft += itemRect.left - listRect.left;
        else if (itemRect.right > listRect.right) list.scrollLeft += itemRect.right - listRect.right;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
